export default __webpack_public_path__ + "static/media/7_3.16c472d8.png";